"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  if (Object.keys(data).length > 1) {
    const _ref = data,
      backgroundColor = _ref.backgroundColor,
      cardList = _ref.cardList,
      themeType = _ref.themeType,
      modTitle = _ref.modTitle,
      desc = _ref.desc,
      mergeComponentStatus = _ref.mergeComponentStatus,
      flexSmallTitle = _ref.flexSmallTitle,
      paddingBottomNum = _ref.paddingBottomNum,
      paddingTopNum = _ref.paddingTopNum,
      fontColor = _ref.fontColor;
    const bgStyle = backgroundColor ? (0, _componentUtils.doComponentsBgColorEvent)(backgroundColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", {
      id: modTitle
    }, /*#__PURE__*/React.createElement(_intlDesignUi.NumberCard, {
      flexTitle: modTitle,
      themeType: themeType,
      desc: desc,
      fontColor: fontColor,
      mergeComponentStatus: mergeComponentStatus,
      flexSmallTitle: flexSmallTitle,
      paddingBottomNum: paddingBottomNum,
      paddingTopNum: paddingTopNum,
      cardList: cardList,
      style: backgroundColor ? bgStyle : {}
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}